import styles from './HomeResponsavel.module.css';
import FooterOpcoes from '../components/FooterOpcoes';
import { useContext } from 'react';
import { ResponsaveisContext } from '../../../shared/contexts/ResponsaveisContext';
import {ResponsavelAluno } from '../../../shared/contexts/ResponsavelAlunoContext';

function HomeResponsavel() {

    //Recebe os context

    const {alunos} = useContext(ResponsavelAluno)
    const {responsaveis} = useContext(ResponsaveisContext)

    //pega o id do responsavel logado
    const id_responsavel = localStorage.getItem("id_responsavel")

    const responsavelEncontrado = responsaveis.find(r => String(r.id_responsavel) === String(id_responsavel))
    const nomeResponsavel = responsavelEncontrado ? responsavelEncontrado.nome_responsavel : ""

 

    const responsavel = {
        nome: "Patrícia Silva"
    };

    const resumoFinanceiro = {
        gastoHoje: 15.90,
        gastoSemana: 127.40,
        limiteDiario: 30.00
    };

    const filhos = [
        {
            id: 1,
            nome: "Maria Silva",
            escola: "Colégio Estrela",
            cantina: "Cantina Central",
            pedidoHoje: "Pedido feito às 12:30",
            gastoHoje: 15.90
        },
        {
            id: 2,
            nome: "João Silva",
            escola: "Colégio Estrela",
            cantina: "Cantina Central",
            pedidoHoje: null,
            gastoHoje: 0
        }
    ];

    const porcentagemLimite = Math.min((resumoFinanceiro.gastoHoje / resumoFinanceiro.limiteDiario) * 100, 100);

    const formatarMoeda = (valor) => {
        return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    };

    return (
        <div className={styles.container}>
            {/* Header */}
            <header className={styles.header}>
                <p className={styles.textoWelcome}>Bem-vindo(a),</p>
                <h1 className={styles.nomeResponsavel}>{nomeResponsavel}</h1>
            </header>



            {/* Conteúdo Principal */}
            <main className={styles.mainContent}>
                {/* Card Resumo Financeiro */}
                <div className={styles.cardResumo}>
                    <div className={styles.cardHeader}>
                        <span className={styles.cardIcon}>📊</span>
                        <span className={styles.cardTitle}>Resumo Financeiro</span>
                    </div>

                    <div className={styles.valoresContainer}>
                        <div className={styles.valorItem}>
                            <span className={styles.valorLabel}>Hoje</span>
                            <span className={styles.valorDestaque}>{formatarMoeda(resumoFinanceiro.gastoHoje)}</span>
                        </div>
                        <div className={styles.valorItem}>
                            <span className={styles.valorLabel}>Esta semana</span>
                            <span className={styles.valorNormal}>{formatarMoeda(resumoFinanceiro.gastoSemana)}</span>
                        </div>
                    </div>

                    <div className={styles.limiteContainer}>
                        <div className={styles.limiteHeader}>
                            <span className={styles.limiteLabel}>📅 Limite diário</span>
                            <span className={styles.limiteValor}>{formatarMoeda(resumoFinanceiro.limiteDiario)}</span>
                        </div>
                        <div className={styles.progressBar}>
                            <div
                                className={styles.progressFill}
                                style={{ width: `${porcentagemLimite}%` }}
                            ></div>
                        </div>
                        <span className={styles.porcentagemTexto}>{Math.round(porcentagemLimite)}% do limite usado</span>
                    </div>
                </div>

                {/* Seção Meus Filhos */}
                <div className={styles.filhosSection}>

                    {
                        alunos.map(item => (
                            <p key={item.id_cliente}>{item.nome}</p>
                        ))
                    }

                    <div className={styles.filhosHeader}>
                        <h2 className={styles.filhosTitle}>Meus Filhos</h2>
                        <span className={styles.verTodos}>Ver todos &gt;</span>
                    </div>

                    <div className={styles.filhosList}>
                        {filhos.map((filho) => (
                            <div key={filho.id} className={styles.filhoCard}>
                                <div className={styles.filhoInfo}>
                                    <div className={styles.avatarContainer}>
                                        <div className={styles.avatar}>
                                            {filho.nome.charAt(0)}
                                        </div>
                                    </div>
                                    <div className={styles.filhoDetalhes}>
                                        <h3 className={styles.filhoNome}>{filho.nome}</h3>
                                        <p className={styles.filhoEscola}>{filho.escola}</p>
                                        <p className={styles.filhoCantina}>{filho.cantina}</p>
                                    </div>
                                </div>

                                <div className={styles.pedidoStatus}>
                                    {filho.pedidoHoje ? (
                                        <span className={styles.statusComPedido}>✓ {filho.pedidoHoje}</span>
                                    ) : (
                                        <span className={styles.statusSemPedido}>Sem pedido hoje</span>
                                    )}
                                </div>

                                <div className={styles.filhoFooter}>
                                    <div className={styles.gastoInfo}>
                                        <span className={styles.gastoLabel}>Gasto hoje</span>
                                        <span className={styles.gastoValor}>{formatarMoeda(filho.gastoHoje)}</span>
                                    </div>
                                    <button className={styles.btnDetalhes}>
                                        Ver detalhes &gt;
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </main>
            <FooterOpcoes typeView="responsavel" />
        </div>
    );
}

export default HomeResponsavel;
